import _ from 'lodash';
import promiseError from 'libs/promiseError';
import {
  FETCH_DEVICE_LIST,
  CLEAR_DEVICE_LIST,
  SET_DEVICE_LIST_SEARCH_TERM
} from 'actions/types';

const fetchDeviceList = (action, state) => {
  const { payload } = action;
  const { status, request, data } = payload;

  if (status === 200) {
    if (data) {
      const list = _.mapKeys(data.data, 'id');
      return {
        ...state,
        list
      };
    }
  }
  if (status === 204) {
    return {
      ...state,
      noData: true
    };
  } else {
    const searchError = promiseError(request);
    return { ...state, searchError };
  }
};

export default function(state = null, action) {
  switch (action.type) {
    case FETCH_DEVICE_LIST:
      return fetchDeviceList(action, state);
    case SET_DEVICE_LIST_SEARCH_TERM:
      return { ...state, ...action.payload };
    case CLEAR_DEVICE_LIST:
      return { ...state, list: null };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/devices.js